import React, { Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './styles/tailwind.css';
import logo from './logo.svg';
import { ClipLoader } from "react-spinners";
// Lazy-loaded Components
const Layout = lazy(() => import('./Components/Layout'));
const Dashboard = lazy(() => import('./Components/Dashboard/DashboardModern'));
const StudentDashboard = lazy(() => import('./Components/Dashboard/StudentDashboard'));
const LoginModern = lazy(() => import('./Components/Auth/LoginModern'));
const AddStudent = lazy(() => import('./Components/AddStudentPremium'));
const ManageStudent = lazy(() => import('./Components/ManageStudent'));
const AddUniversity = lazy(() => import('./Components/AddUniversity'));
const ManageUniversity = lazy(() => import('./Components/ManageUniversity'));
const AddCourse = lazy(() => import('./Components/AddCourse'));
const ManageCourse = lazy(() => import('./Components/ManageCourse'));
const AddSpecialization = lazy(() => import('./Components/AddSpecialization'));
const ManageSpecialization = lazy(() => import('./Components/ManageSpecialization'));
const AddSubject = lazy(() => import('./Components/AddSubject'));
const ManageSubject = lazy(() => import('./Components/ManageSubject'));
const AddSession = lazy(() => import('./Components/AddSession'));
const ManageSession = lazy(() => import('./Components/ManageSession'));
const AddBook = lazy(() => import('./Components/AddBook'));
const ManageBook = lazy(() => import('./Components/ManageBook'));
const ChangePassword = lazy(() => import('./Components/ChangePassword'));
const GetParticlarStudent = lazy(() => import('./Components/ParticularStudent'));
const GetParticularCourse = lazy(() => import('./Components/ParticularCourse'));
const GetParticularSpecialization = lazy(() => import('./Components/ParticularSpecialization'));
const GetParticularUniversity = lazy(() => import('./Components/ParticularUniversity'));
const GetParticularSession = lazy(() => import('./Components/ParticularSession'));
const GetParticlarBook = lazy(() => import('./Components/ParticularBook'));
const GetParticularSubject = lazy(() => import('./Components/ParticularSubject'));
const AddResult = lazy(() => import('./Components/AddResult'));
const Login = lazy(() => import('./Components/Login'));
const SearchResult = lazy(() => import('./Components/SearchResult'));
const ManageResult = lazy(() => import('./Components/ManageResult'));
const GetParticlarResult = lazy(() => import('./Components/ParticularResult'));
const IdCard = lazy(() => import('./Components/IdCard'));
const Library = lazy(() => import('./Components/Library'));
const Feedback = lazy(() => import('./Components/Feedback'));
const Examination = lazy(() => import('./Components/Examination'));
const Profile = lazy(() => import('./Components/Profile'));
const PrintResult = lazy(() => import('./Components/PrintResult'));
const AdminUsers = lazy(() => import('./Components/AdminUsers'));
const AdminRoles = lazy(() => import('./Components/AdminRoles'));
const ActivityLogs = lazy(() => import('./Components/ActivityLogs'));
const MyAccount = lazy(() => import('./Components/MyAccount'));
const ResultsSearch = lazy(() => import('./Components/ResultsSearch'));
const ResultDetail = lazy(() => import('./Components/ResultDetail'));
const ResultsDetailsView = lazy(() => import('./Components/ResultsDetailsView'));
const AutoBackup = lazy(() => import('./Components/AutoBackup'));
const Viewcertificate = lazy(() => import('./Components/viewcertificate'));
const ManageCertificate = lazy(() => import('./Components/ManageCertificate'));
const AddCertificate = lazy(() => import('./Components/AddCertificate'));
const ContactUs = lazy(() => import('./Components/ContactUs'));
const ChangePicture = lazy(() => import('./Components/ChangePicture'));
const News = lazy(() => import('./Components/News'));
const Timetable = lazy(() => import('./Components/Timetable'));


// Role-based Dashboard Component
function RoleBasedDashboard() {
  const role = localStorage.getItem('role') || 'student';
  
  if (role === 'admin') {
    return <Layout components={Dashboard} />;
  }
  return <Layout components={StudentDashboard} />;
}

function App() {
  return (
    <Router>
      <Suspense fallback={<div className="loader-container">
        <ClipLoader color="#0d6efd" size={50} />
      </div>}>
        <Routes>
          <Route path="/" element={<LoginModern />} />
          <Route path="/Results" element={<ResultsSearch />} />
          <Route path="/Results/Details/:Id" element={<ResultsDetailsView />} />
          <Route path="/Results/DetailSection/:Id" element={<ResultDetail />} />
          <Route path="/Dashboard" element={<RoleBasedDashboard />} />
          <Route path="/Auto-Backup" element={<Layout components={AutoBackup} />} />
          <Route path="/Change-Picture" element={<Layout components={ChangePicture} />} />

          <Route path="Add-Student" element={<Layout components={AddStudent} />} />
          <Route path="Add-Result/:Id" element={<Layout components={AddResult} />} />
          <Route path="Add-Results" element={<Layout components={SearchResult} />} />
          <Route path="Search-Student" element={<Layout components={SearchResult} />} />
          <Route path="View-Certificate/:Id" element={<Viewcertificate />} />

          <Route path="Get-Particular-Student/:Id" element={<Layout components={GetParticlarStudent} />} />
          <Route path="Get-Particular-Result/:Id" element={<Layout components={GetParticlarResult} />} />
          <Route path="Get-Particular-Session/:Id" element={<Layout components={GetParticularSession} />} />
          <Route path="Get-Particular-University/:Id" element={<Layout components={GetParticularUniversity} />} />
          <Route path="Get-Particular-Course/:Id" element={<Layout components={GetParticularCourse} />} />
          <Route path="Get-Particular-Specialization/:Id" element={<Layout components={GetParticularSpecialization} />} />
          <Route path="Get-Particular-Book/:Id" element={<Layout components={GetParticlarBook} />} />
          <Route path="Get-Particular-Subject/:Id" element={<Layout components={GetParticularSubject} />} />

          <Route path="Manage-Student" element={<Layout components={ManageStudent} />} />
          <Route path="Add-University" element={<Layout components={AddUniversity} />} />
          <Route path="Manage-University" element={<Layout components={ManageUniversity} />} />
          <Route path="Manage-Result" element={<Layout components={ManageResult} />} />
          <Route path="Manage-Certificate" element={<Layout components={ManageCertificate} />} />
          <Route path="Add-Certificate" element={<Layout components={AddCertificate} />} />
          <Route path="Contact-Us" element={<Layout components={ContactUs} />} />

          <Route path="Add-Course" element={<Layout components={AddCourse} />} />
          <Route path="Manage-Course" element={<Layout components={ManageCourse} />} />
          <Route path="Add-Specialization" element={<Layout components={AddSpecialization} />} />
          <Route path="Manage-Specialization" element={<Layout components={ManageSpecialization} />} />
          <Route path="Add-Subject" element={<Layout components={AddSubject} />} />
          <Route path="Manage-Subject" element={<Layout components={ManageSubject} />} />
          <Route path="Add-Session" element={<Layout components={AddSession} />} />
          <Route path="Manage-Session" element={<Layout components={ManageSession} />} />
          <Route path="Add-Book" element={<Layout components={AddBook} />} />
          <Route path="Manage-Book" element={<Layout components={ManageBook} />} />
          <Route path="Print-Result/:Id" element={<PrintResult />} />
          <Route path="Change-Password" element={<Layout components={ChangePassword} />} />
          <Route path="Id-Card" element={<Layout components={IdCard} />} />
          <Route path="Examination" element={<Layout components={Examination} />} />
          <Route path="Library" element={<Layout components={Library} />} />
          <Route path="Feedback" element={<Layout components={Feedback} />} />
          <Route path="Profile" element={<Layout components={Profile} />} />
          <Route path="News" element={<Layout components={News} />} />
          <Route path="Timetable" element={<Layout components={Timetable} />} />
          <Route path="Admin-Users" element={<Layout components={AdminUsers} />} />
          <Route path="Admin-Roles" element={<Layout components={AdminRoles} />} />
          <Route path="Activity-Logs" element={<Layout components={ActivityLogs} />} />
          <Route path="My-Account" element={<Layout components={MyAccount} />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
